import { colors } from '@design-system/styles/colors/colors.config';

export function getUserInitials(userName: string): string {
  if (!userName) return '';

  const localPart = (userName.split('@')[0] || '').trim();
  if (!localPart) return '';

  const delimiters = ['.', '-', '_'];
  let parts: string[] = [];

  for (const delimiter of delimiters) {
    if (localPart.includes(delimiter)) {
      parts = localPart.split(delimiter).filter((p) => p.trim().length > 0);
      if (parts.length > 0) {
        break;
      }
    }
  }

  if (parts.length > 0) {
    return parts
      .map((part) => part.charAt(0).toUpperCase())
      .slice(0, 2)
      .join('');
  } else {
    return localPart.substring(0, Math.min(localPart.length, 2)).toUpperCase();
  }
}

export function getUserColor(userName: string): string {
  if (!userName) return colors['gray-500']!;
  const colorPalette = [
    colors['blue-500'],
    colors['green-500'],
    colors['yellow-600'],
    colors['red-500'],
    '#696cff',
    colors['blue-600'],
    colors['green-600'],
    colors['orange-300']
  ];

  let hash = 0;
  for (let i = 0; i < userName.length; i++) {
    const char = userName.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }

  return colorPalette[Math.abs(hash) % colorPalette.length]!;
}
